import React, { useEffect, useState } from "react";
import { Col, Flex, Row, Typography, Button, Spin } from "antd";
import { Expert, fetchHomepageExpertsMap } from "../code/utils";
import { useNavigate } from "react-router-dom";
const cardImage = (expert: Expert) =>
  expert.image || `/${expert.value}.jpg`;

const Discover: React.FC = () => {
  const navigate = useNavigate();
  const [experts, setExperts] = useState<Expert[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHomepageExpertsMap()
      .then((map) => setExperts(Array.from(map.values())))
      .catch((err) => console.error("Failed to load experts:", err))
      .finally(() => setLoading(false));
  }, []);

  const scrollToExperts = () => {
    document.getElementById("experts-section")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto", width: "100%" }}>
      <Flex style={{ width: "100%", height: "100%" }} vertical>
        <div style={{
          textAlign: "left",
          padding: "80px 0 60px 0",
          background: "#F8F5F0",
        }}>
          <h1 style={{
            fontSize: "48px",
            fontWeight: "normal",
            color: "#032539",
            margin: "0 0 24px 0",
            fontFamily: "'Libre Baskerville', serif",
            lineHeight: 1.2,
          }}>
            Talk to Industry Experts
          </h1>
          <p style={{
            fontSize: "18px",
            color: "#5C5C5C",
            fontFamily: "Inter, sans-serif",
            lineHeight: 1.5,
            maxWidth: "600px",
            margin: "0 0 40px",
          }}>
            Connect with leading professionals and get instant answers to your questions. Chat with experts who are always available to help.
          </p>
          <div style={{ display: "flex", gap: "16px", justifyContent: "start", flexWrap: "wrap" }}>
            <Button
              size="large"
              style={{
                backgroundColor: "#032539",
                borderColor: "#032539",
                color: "white",
                borderRadius: "8px",
                padding: "12px 24px",
                height: "auto",
                fontSize: "16px",
                fontFamily: "Inter, sans-serif",
                fontWeight: "500",
              }}
              onClick={scrollToExperts}
            >
              Find an Expert
            </Button>
            <Button
              size="large"
              style={{
                backgroundColor: "#EAE4DD",
                borderColor: "#EAE4DD",
                color: "#032539",
                borderRadius: "8px",
                padding: "12px 24px",
                height: "auto",
                fontSize: "16px",
                fontFamily: "Inter, sans-serif",
                fontWeight: "500",
              }}
              onClick={scrollToExperts}
            >
              Browse All Experts
            </Button>
          </div>
        </div>

        <div id="experts-section">
          {loading ? (
            <Flex justify="center" style={{ padding: 48 }}>
              <Spin size="large" />
            </Flex>
          ) : (
            <Row gutter={[13, 13]}>
              {experts.map((x) => {
                const isClickable = x.isPublished === true;
                return (
                  <Col key={x.value} span={6}>
                    <div
                      style={{
                        backgroundImage: `url(${cardImage(x)})`,
                        backgroundSize: "cover",
                        cursor: isClickable ? "pointer" : "not-allowed",
                        paddingBottom: "135%",
                        borderRadius: 10,
                        position: "relative",
                        backgroundPosition: "center center",
                        overflow: "hidden",
                        opacity: isClickable ? 1 : 0.95,
                      }}
                      onClick={() => isClickable && navigate("/chat/" + x.value)}
                    >
                      <div
                        style={{
                          position: "absolute",
                          inset: 0,
                          background: "linear-gradient(transparent 50%, rgba(0,0,0,0.5))",
                        }}
                      />
                      <div style={{ position: "absolute", bottom: 20, left: 13, right: 13 }}>
                        <Typography.Paragraph style={{ fontWeight: "bold", textAlign: "center", marginBottom: 0, fontSize: 18, color: "#FFF" }}>
                          {x.label}
                        </Typography.Paragraph>
                        <Typography.Paragraph style={{ textAlign: "center", marginBottom: 0, color: "#FFF" }}>
                          {x.subtitle}
                        </Typography.Paragraph>
                        {!isClickable && (
                          <Typography.Paragraph style={{ textAlign: "center", marginBottom: 0, color: "#FFF", fontSize: 12, fontStyle: "italic", marginTop: 4 }}>
                            Coming Soon
                          </Typography.Paragraph>
                        )}
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          )}
        </div>
      </Flex>
    </div>
  );
};

export default Discover;
